import { Goal } from '@/types/financial';
import { v4 as uuidv4 } from 'uuid';
import {
  saveGoalToSupabase,
  deleteGoalFromSupabase,
} from '@/lib/supabase-operations';
import { logger } from '@/utils/logger';

export const createGoal = async (
  goalData: Omit<Goal, 'id' | 'createdAt'>
): Promise<Goal> => {
  logger.info('Creating goal', { name: goalData.name });

  const newGoal: Goal = {
    ...goalData,
    id: uuidv4(),
    createdAt: new Date().toISOString(),
  };

  await saveGoalToSupabase(newGoal);
  logger.info('Goal created successfully', { id: newGoal.id });
  
  return newGoal;
};

export const updateGoal = async (
  id: string,
  updates: Partial<Goal>,
  currentGoal: Goal
): Promise<Goal> => {
  logger.info('Updating goal', { id });

  const updatedGoal = { ...currentGoal, ...updates };
  
  await saveGoalToSupabase(updatedGoal);
  logger.info('Goal updated successfully', { id });
  
  return updatedGoal;
};

export const deleteGoal = async (id: string): Promise<void> => {
  logger.info('Deleting goal', { id });
  await deleteGoalFromSupabase(id);
  logger.info('Goal deleted successfully', { id });
};
